module.exports = __webpack_public_path__ + "static/media/d93a15e8-d11b-4e19-be38-fffa3c227d32.0893f680.JPG";